import React from 'react';
import { NumericFormat, NumericFormatProps, SourceInfo } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string | undefined } }) => void;
  name: string;
}

const NumericFormatInput = React.forwardRef<NumericFormatProps, CustomProps>(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values, sourceInfo: SourceInfo) => {
        if (sourceInfo.source !== 'event') return;
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      allowNegative
      valueIsNumericString
      decimalScale={2}
    />
  );
});

export default NumericFormatInput;
